"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('play-once', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 7.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M39.8232939,18.2304639 C39.7018691,18.9888904 39.5195287,19.7269749 39.2814486,20.4395418 C38.7629566,21.9913723 37.9801001,23.4221769 36.986338,24.6784963 C34.4222235,27.9200639 30.4540093,30 26,30 L12,30 C5.39697266,30 0,24.6784963 0,18 C0,11.3501587 5.39624023,6 12,6 L40,6"
  }), _react.default.createElement("polyline", {
    points: "34 0 40 6 34 12"
  }), _react.default.createElement("path", {
    d: "M20,12 L20,24"
  }), _react.default.createElement("polyline", {
    points: "20 12 17 15 15.5 16.5"
  }))));
});

exports.default = _default;